import {
  Table,
  Tr,
  Td,
  Tbody,
  Thead,
  Th,
  TableContainer,
  Text,
  VStack,
  HStack,
  Input,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useStores } from '../store/store_context';
import { useEffect, useRef, useState } from 'react';
import UserModal from './user_modal';
import UserEditForm from './user_forms/user_edit_form';
import { deleteUserById, updateUserById } from '../store/api_funcs';
import { MdDelete } from 'react-icons/md';

const UserTable = ({
  getTableUsers,
  users = [],
  rolesForUserForm,
  panels,
  getTablePanels,
}) => {
  const { pageStore } = useStores();
  const [grouped, setGrouped] = useState([[]]);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const toast = useToast();
  const tableContainerProps = {
    width: '100%',
    border: '1px solid rgba(255,255,255,0.14)',
    borderRadius: '8px',
    backgroundColor: 'rgba(255,255,255,0.025)',
    overflow: 'hidden',
  };
  const rowProps = {
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    _hover: { backgroundColor: 'rgba(139,92,246,0.18)' },
  };
  const cellProps = {
    borderRight: '1px solid rgba(255,255,255,0.08)',
  };
  const permissionIsEnabled = value => value === true || Number(value) === 1;
  const canDeleteUsers =
    [
      pageStore.see_all_panels,
      pageStore.add_panels,
      pageStore.update_firmware,
      pageStore.see_all_users,
      pageStore.add_users,
      pageStore.edit_themes,
      pageStore.get_errors,
      pageStore.add_roles,
      pageStore.analytics,
    ].every(permissionIsEnabled) &&
    !permissionIsEnabled(pageStore.only_myself) &&
    !permissionIsEnabled(pageStore.only_my_panel);

  const requestDelete = user_id => {
    setUserToDelete(user_id);
    onOpen();
  };

  const handleDelete = async () => {
    if (!canDeleteUsers) {
      toast({
        title: 'Недостаточно прав',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      onClose();
      return;
    }

    try {
      setIsDeleting(true);
      await deleteUserById(userToDelete, pageStore.token);
      await getTableUsers();
      toast({
        title: 'Пользователь удален',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    } catch (error) {
      toast({
        title: 'Не удалось удалить пользователя',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDeleting(false);
    }
  };
  const userTableText = {
    RU: [
      'ФИО',
      'никнейм',
      'краткое описание',
      'телефон',
      'роль',
      'тип пользователя',
    ],
    EN: ['name', 'nickname', 'description', 'phone', 'role', 'customer type'],
  };
  // {
  //   adress: adress,
  //   usernames: usernames,
  // }
  function searchUsers(users, searchParams) {
    if (users != undefined) {
      return users
        .filter(user => {
          // Проверка поиска по адресу
          const matchType = searchParams.type
            ? user.customer_type
                .toLowerCase()
                .includes(searchParams.type.toLowerCase())
            : true;

          // Проверка поиска по именам пользователей
          const matchUsernames = searchParams.username
            ? user.username
                .toLowerCase()
                .includes(searchParams.username.toLowerCase())
            : true;

          // Возврат объекта панели, если он соответствует всем критериям
          return matchType && matchUsernames;
        })
        .map(user => ({
          ...user,
        }));
    } else {
      return [];
    }
  }
  function groupUsersByCreator(users) {
    // Объект для хранения сгруппированных пользователей
    const groupedUsers = {};

    // Группировка пользователей по creator_username
    users.forEach(user => {
      const creator = user.creator_username || 'null'; // Используем 'null' для случаев, когда creator_username равен null

      if (!groupedUsers[creator]) {
        groupedUsers[creator] = [];
      }

      groupedUsers[creator].push(user);
    });

    // Преобразование объекта в массив списков пользователей
    return Object.values(groupedUsers);
  }
  const [username, setUsername] = useState('');
  const [type, setType] = useState('');
  useEffect(() => {
    getTableUsers();
  }, []);
  useEffect(() => {
    if (users != null && users != undefined) {
      setGrouped(
        groupUsersByCreator(
          searchUsers(users, { type: type, username: username })
        )
      );
    }
  }, [users, username, type]);
  // useEffect(() => {
  //   console.log(users);
  // }, [users]);
  return (
    <VStack width="100%">
      <HStack width={'100%'}>
        <Input
          width={'20%'}
          placeholder="тип пользователя"
          onChange={e =>
            e.target.value == '' ? setType(false) : setType(e.target.value)
          }
        ></Input>
        <Input
          width={'20%'}
          placeholder="никнейм"
          onChange={e =>
            e.target.value == ''
              ? setUsername(false)
              : setUsername(e.target.value)
          }
        ></Input>
      </HStack>
      {grouped != null && grouped != []
        ? grouped.map((users_g, index) => {
            return (
              <>
                <Text fontSize={24} alignSelf={'flex-start'} color={'white'} fontWeight={700}>
                  {users_g[0]?.creator_username
                    ? users_g[0].creator_username
                    : 'Без создателя'}
                </Text>
                <TableContainer {...tableContainerProps}>
                  <Table variant={'unstyled'}>
                    <Thead>
                      <Tr>
                        <Th>{userTableText[pageStore.lang][0]}</Th>
                        <Th>{userTableText[pageStore.lang][1]}</Th>
                        <Th maxW={'300px'}>
                          {userTableText[pageStore.lang][2]}
                        </Th>
                        <Th>{userTableText[pageStore.lang][3]}</Th>
                        <Th>{userTableText[pageStore.lang][4]}</Th>
                        <Th>{userTableText[pageStore.lang][5]}</Th>
                        <Th>Действия</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {users_g !== null
                        ? users_g.map((elem, index) => {
                            return (
                              <Tr key={index} {...rowProps}>
                                <Td {...cellProps}>
                                  {elem.name}
                                </Td>
                                <Td {...cellProps}>
                                  {elem.username}
                                </Td>
                                <Td
                                  {...cellProps}
                                  maxW={'300px'}
                                  whiteSpace={'pre-line'}
                                >
                                  <Text>{elem.description}</Text>
                                </Td>
                                <Td {...cellProps}>
                                  {elem.phone}
                                </Td>
                                <Td {...cellProps}>
                                  {elem.role_name}
                                </Td>
                                <Td {...cellProps}>
                                  {elem.customer_type}
                                </Td>
                                <Td {...cellProps}>
                                  <HStack>
                                    <UserModal>
                                      <UserEditForm
                                        updateUsersTable={getTableUsers}
                                        user_id={elem.user_id}
                                        onSubmit={updateUserById}
                                        rolesForUserForm={rolesForUserForm}
                                        panels={panels}
                                        getTablePanels={getTablePanels}
                                      />
                                    </UserModal>
                                    {canDeleteUsers ? (
                                      <Button
                                        aria-label="Удалить пользователя"
                                        backgroundColor={'rgba(239,68,68,0.86)'}
                                        color="white"
                                        _hover={{ backgroundColor: '#E05A5A' }}
                                        onClick={() =>
                                          requestDelete(elem.user_id)
                                        }
                                      >
                                        <MdDelete />
                                      </Button>
                                    ) : null}
                                  </HStack>
                                </Td>
                              </Tr>
                            );
                          })
                        : null}
                    </Tbody>
                  </Table>
                </TableContainer>
              </>
            );
          })
        : null}
      <Text fontSize={24} alignSelf={'flex-start'} color={'white'} fontWeight={700}>
        Все пользователи
      </Text>
      <TableContainer {...tableContainerProps}>
        <Table variant={'unstyled'}>
          <Thead>
            <Tr>
              <Th>{userTableText[pageStore.lang][0]}</Th>
              <Th>{userTableText[pageStore.lang][1]}</Th>
              <Th>{userTableText[pageStore.lang][2]} </Th>
              <Th>{userTableText[pageStore.lang][3]}</Th>
              <Th>{userTableText[pageStore.lang][4]}</Th>
              <Th>{userTableText[pageStore.lang][5]}</Th>
              <Th>Действия</Th>
            </Tr>
          </Thead>
          <Tbody>
            {users !== null
              ? users.map((elem, index) => {
                  return (
                    <Tr key={index} {...rowProps}>
                      <Td {...cellProps}>{elem.name}</Td>
                      <Td {...cellProps}>{elem.username}</Td>
                      <Td
                        {...cellProps}
                        maxW={'300px'}
                        whiteSpace={'pre-line'}
                      >
                        {elem.description}
                      </Td>
                      <Td {...cellProps}>{elem.phone}</Td>
                      <Td {...cellProps}>
                        {elem.role_name}
                      </Td>
                      <Td {...cellProps}>
                        {elem.customer_type}
                      </Td>
                      <Td {...cellProps}>
                        <HStack>
                          <UserModal>
                            <UserEditForm
                              updateUsersTable={getTableUsers}
                              user_id={elem.user_id}
                              onSubmit={updateUserById}
                              rolesForUserForm={rolesForUserForm}
                              panels={panels}
                              getTablePanels={getTablePanels}
                            />
                          </UserModal>
                          {canDeleteUsers ? (
                            <Button
                              aria-label="Удалить пользователя"
                              backgroundColor={'rgba(239,68,68,0.86)'}
                              color="white"
                              _hover={{ backgroundColor: '#E05A5A' }}
                              onClick={() => requestDelete(elem.user_id)}
                            >
                              <MdDelete />
                            </Button>
                          ) : null}
                        </HStack>
                      </Td>
                    </Tr>
                  );
                })
              : null}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent
            fontFamily={"'Jura', sans-serif"}
            backgroundColor={'#1b1c2b'}
            color={'white'}
          >
            <AlertDialogHeader>Удалить пользователя?</AlertDialogHeader>
            <AlertDialogBody>Действие нельзя отменить.</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Отмена
              </Button>
              <Button
                ml={3}
                colorScheme="red"
                isLoading={isDeleting}
                onClick={handleDelete}
              >
                Удалить
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </VStack>
  );
};

export default UserTable;
